import _asyncToGenerator from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/usr/src/app/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { BaseRequestPolicy } from "./requestPolicy";
import { DEFAULT_CLIENT_MAX_RETRY_INTERVAL, DEFAULT_CLIENT_RETRY_COUNT, DEFAULT_CLIENT_RETRY_INTERVAL, isNumber, shouldRetry, updateRetryData } from "../util/exponentialBackoffStrategy";
import { Constants } from "../util/constants";
import { RestError } from "../restError";
import { delay } from "../util/delay";
import { logger } from "../log";
/**
 * Policy that retries the request as many times as configured for as long as the max retry time interval specified, each retry waiting longer to begin than the last time.
 * @param retryCount - Maximum number of retries.
 * @param retryInterval - Base time between retries.
 * @param maxRetryInterval - Maximum time to wait between retries.
 */

export function exponentialRetryPolicy(retryCount, retryInterval, maxRetryInterval) {
  return {
    create: function create(nextPolicy, options) {
      return new ExponentialRetryPolicy(nextPolicy, options, retryCount, retryInterval, maxRetryInterval);
    }
  };
}
/**
 * Describes the Retry Mode type. Currently supporting only Exponential.
 */

export var RetryMode;

(function (RetryMode) {
  /**
   * Currently supported retry mode.
   * Each time a retry happens, it will take exponentially more time than the last time.
   */
  RetryMode[RetryMode["Exponential"] = 0] = "Exponential";
})(RetryMode || (RetryMode = {}));

export var DefaultRetryOptions = {
  maxRetries: DEFAULT_CLIENT_RETRY_COUNT,
  retryDelayInMs: DEFAULT_CLIENT_RETRY_INTERVAL,
  maxRetryDelayInMs: DEFAULT_CLIENT_MAX_RETRY_INTERVAL
};
/**
 * Instantiates a new "ExponentialRetryPolicyFilter" instance.
 */

export var ExponentialRetryPolicy = /*#__PURE__*/function (_BaseRequestPolicy) {
  _inherits(ExponentialRetryPolicy, _BaseRequestPolicy);

  var _super = _createSuper(ExponentialRetryPolicy);

  /**
   * @param nextPolicy - The next RequestPolicy in the pipeline chain.
   * @param options - The options for this RequestPolicy.
   * @param retryCount - The client retry count.
   * @param retryInterval - The client retry interval, in milliseconds.
   * @param minRetryInterval - The minimum retry interval, in milliseconds.
   * @param maxRetryInterval - The maximum retry interval, in milliseconds.
   */
  function ExponentialRetryPolicy(nextPolicy, options, retryCount, retryInterval, maxRetryInterval) {
    var _this;

    _classCallCheck(this, ExponentialRetryPolicy);

    _this = _super.call(this, nextPolicy, options);
    _this.retryCount = isNumber(retryCount) ? retryCount : DEFAULT_CLIENT_RETRY_COUNT;
    _this.retryInterval = isNumber(retryInterval) ? retryInterval : DEFAULT_CLIENT_RETRY_INTERVAL;
    _this.maxRetryInterval = isNumber(maxRetryInterval) ? maxRetryInterval : DEFAULT_CLIENT_MAX_RETRY_INTERVAL;
    return _this;
  }

  _createClass(ExponentialRetryPolicy, [{
    key: "sendRequest",
    value: function sendRequest(request) {
      var _this2 = this;

      return this._nextPolicy.sendRequest(request.clone()).then(function (response) {
        return retry(_this2, request, response);
      }).catch(function (error) {
        return retry(_this2, request, error.response, undefined, error);
      });
    }
  }]);

  return ExponentialRetryPolicy;
}(BaseRequestPolicy);

function retry(_x, _x2, _x3, _x4, _x5) {
  return _retry.apply(this, arguments);
}

function _retry() {
  _retry = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(policy, request, response, retryData, requestError) {
    var shouldPolicyRetry, isAborted, res, err;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            shouldPolicyRetry = function _shouldPolicyRetry(responseParam) {
              var statusCode = responseParam === null || responseParam === void 0 ? void 0 : responseParam.status;

              if (statusCode === 503 && (response === null || response === void 0 ? void 0 : response.headers.get(Constants.HeaderConstants.RETRY_AFTER))) {
                return false;
              }

              if (statusCode === undefined || statusCode < 500 && statusCode !== 408 || statusCode === 501 || statusCode === 505) {
                return false;
              }

              return true;
            };

            retryData = updateRetryData({
              retryInterval: policy.retryInterval,
              minRetryInterval: 0,
              maxRetryInterval: policy.maxRetryInterval
            }, retryData, requestError);
            isAborted = request.abortSignal && request.abortSignal.aborted;

            if (!(!isAborted && shouldRetry(policy.retryCount, shouldPolicyRetry, retryData, response))) {
              _context.next = 19;
              break;
            }

            logger.info("Retrying request in ".concat(retryData.retryInterval));
            _context.prev = 5;
            _context.next = 8;
            return delay(retryData.retryInterval);

          case 8:
            _context.next = 10;
            return policy._nextPolicy.sendRequest(request.clone());

          case 10:
            res = _context.sent;
            return _context.abrupt("return", retry(policy, request, res, retryData));

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](5);
            return _context.abrupt("return", retry(policy, request, response, retryData, _context.t0));

          case 17:
            _context.next = 25;
            break;

          case 19:
            if (!(isAborted || requestError || !response)) {
              _context.next = 24;
              break;
            }

            // If the operation failed in the end, return all errors instead of just the last one
            err = retryData.error || new RestError("Failed to send the request.", RestError.REQUEST_SEND_ERROR, response && response.status, response && response.request, response);
            throw err;

          case 24:
            return _context.abrupt("return", response);

          case 25:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[5, 14]]);
  }));
  return _retry.apply(this, arguments);
}